import { IInventoryIn } from "../../models/input/agendaApi/IInventoryIn";
import { IProductPriceIn } from "../../models/input/agendaApi/IProductPriceIn";
import * as ApiWithToken from "../callApiWithToken";


const pricesService = {
    getProducts:async function(posCode:string, brandId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_MASTER_DATA_API + `Products/GetProductsByBrand?posCode=${posCode}&brandId=${brandId}`);
    },
    getBrands: async function(){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `PriceShoppingProducts/getBrands`);
    },
    getPricesProducts: async function(posCode:string, brandId: number){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `PriceShoppingProducts/getPriceShoppingProducts?posCode=${posCode}&BrandID=${brandId}`);
    },
    getPriceProductBySku: async function(posCode:string, sku: string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `PriceShoppingProducts/getPriceShoppingProductsBySKU?posCode=${posCode}&SKU=${sku}`);
    },
    getPromos: async function(languageId:number){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `PriceShoppingProducts/getPriceShoppingPromo?LanguageID=${languageId}`);
    },
    updateProduct: async function(productPrice:IProductPriceIn){
        return  ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API +  `PriceShoppingProducts/UpdateProduct`, productPrice);
    },
    
}
export default pricesService;
